/** Cloudinary HEIC/raw URLs do not render in Chrome; f_auto serves jpg/webp. */
export function toBrowserImageUrl(url: string): string {
  const src = String(url || '').trim();
  if (!src) return src;
  if (!/res\.cloudinary\.com\/[^/]+\/image\/upload\//.test(src)) return src;
  if (/\/image\/upload\/(?:[^/]*f_auto)/.test(src)) return src;
  return src.replace('/image/upload/', '/image/upload/f_auto,q_auto/');
}
